import { defineStore } from 'pinia';
import api from '@/api/incidentsAPI';
import type { Incident } from '@/types/incidentsTypes';

export const useIncidentStore = defineStore('incidents', {
  state: () => ({
    incidents: [] as Incident[],
    searchTerm: '',
    detailedIncidents: new Set<number>(),
    loading: false,
    error: null as string | null,
    pagination: {
      page: 1,
      pageSize: 10,
      total: 0
    }
  }),

  getters: {
    sortedIncidents: (state) => {
      return state.incidents.slice().sort(
        (a: Incident, b: Incident) => new Date(b.incident_date).getTime() - new Date(a.incident_date).getTime()
      );
    },
    
    isDetailed: (state) => (id: number) => state.detailedIncidents.has(id)
  },

  actions: {
    async fetchIncidents() {
      this.loading = true;
      this.error = null;

      try {
        const response = await api.getIncidents(
          this.pagination.page,
          this.pagination.pageSize,
          this.searchTerm
        );

        this.incidents = response.results;
        this.pagination.total = response.count;
      } catch (error) {
        this.error = error instanceof Error ? error.message: 'Error desconocido';
        console.error('Error fetching incidents:', error)
      } finally {
        this.loading = false;
      }
    },

    async createIncident(data: any) {
      const response = await api.createIncident(data);
      await this.fetchIncidents();
      return response;
    },

    // Nueva acción para actualizar una incidencia
    async updateIncident(id: number, data: any) {
      try {
        const response = await api.updateIncident(id, data);
        // Actualizar la lista de incidencias
        await this.fetchIncidents();
        return response;
      } catch (error) {
        console.error('Error updating incident:', error);
        throw error;
      }
    },

    // Nueva acción para obtener detalles de una incidencia
    /* async fetchIncidentDetails(id: number) {
      try {
        const incident = await api.getIncidentDetails(id);
        return incident;
      } catch (error) {
        console.error('Error fetching incident details:', error);
        throw error;
      }
    }, */

    setSearchTerm(term: string) {
      this.searchTerm = term;
      // Resetear a primera página al buscar
      this.pagination.page = 1;
      this.fetchIncidents()
    },

    toggleDetail(id: number) {
      if (this.detailedIncidents.has(id)) {
        this.detailedIncidents.delete(id);
      } else {
        this.detailedIncidents.add(id);
      }
    },
    
    /* async fetchOperators() {
      const response = await axios.get('/api/operadores/');
      this.operators = response.data;
    } */
  }
});
